/**
 * Table component styles for data display.
 */
import * as stylex from "@stylexjs/stylex";

import { colors, fontSize, radius, space } from "../tokens.stylex";

const styles = stylex.create({
  container: {
    overflow: "hidden",
    borderRadius: radius.lg,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
  },
  table: {
    width: "100%",
  },
  thead: {
    backgroundColor: colors.muted,
  },
  theadAlt: {
    backgroundColor: "rgba(38,38,38,0.5)",
  },
  th: {
    paddingInline: space.md,
    paddingBlock: space.md,
    textAlign: "left",
    fontWeight: 500,
    fontSize: fontSize.sm,
    color: colors.foregroundMuted,
  },
  thRight: {
    textAlign: "right",
  },
  tr: {
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
    ":hover": {
      backgroundColor: "rgba(38,38,38,0.5)",
    },
  },
  td: {
    paddingInline: space.md,
    paddingBlock: space.md,
  },
  tdRight: {
    textAlign: "right",
  },
  empty: {
    paddingInline: space.md,
    paddingBlock: space["2xl"],
    textAlign: "center",
    color: colors.foregroundMuted,
  },
});

// Export styles for direct use with stylex.props()
export const table = styles;
